













import { Vue, Prop, Component } from 'vue-property-decorator';
import { VBTooltip } from 'bootstrap-vue';

@Component({
    directives: {
        'b-tooltip': VBTooltip,
    },
})
export default class AbcToolButton extends Vue {
    @Prop({ type: Boolean }) isSecondary!: boolean;
    @Prop({ type: Boolean }) isDisabled!: boolean;
    @Prop({ type: Boolean }) isSuccess!: boolean;
    @Prop({ type: Boolean }) isDanger!: boolean;
    @Prop({ type: Boolean }) isWarning!: boolean;
    @Prop({ type: Boolean }) isInfo!: boolean;
    @Prop({ type: Boolean }) isActive!: boolean;
    @Prop() title!: string;

    private onClick(){
        if(!this.isDisabled){
            this.$emit('click')
        }
    }
    private get btnClass(): { [key: string]: boolean } {
        const isPrimary = !this.isSecondary && !this.isSuccess && !this.isDanger && !this.isWarning && !this.isInfo;
        return {
            "effect-on-click": !this.isDisabled,
            "hover:bg-bg-500": !this.isDisabled,
            "cursor-not-allowed": this.isDisabled,

            "text-primary-500 dark:text-primary-dark-500": isPrimary && !this.isDisabled,
            "text-secondary-500 dark:text-secondary-dark-500": this.isSecondary && !this.isDisabled,
            "text-success-500 dark:text-success-dark-500": this.isSuccess && !this.isDisabled,
            "text-danger-500 dark:text-danger-dark-500": this.isDanger && !this.isDisabled,
            "text-warning-500 dark:text-warning-dark-500": this.isWarning && !this.isDisabled,
            "text-info-500 dark:text-info-dark-500": this.isInfo && !this.isDisabled,

            "text-primary-200 dark:text-primary-dark-200": isPrimary && this.isDisabled,
            "text-secondary-300 dark:text-secondary-dark-200": this.isSecondary && this.isDisabled,
            "text-success-300 dark:text-success-dark-200": this.isSuccess && this.isDisabled,
            "text-danger-200 dark:text-danger-dark-200": this.isDanger && this.isDisabled,
            "text-warning-300 dark:text-warning-dark-200": this.isWarning && this.isDisabled,
            "text-info-200 dark:text-info-dark-200": this.isInfo && this.isDisabled,

            "bg-bg-100 dark:bg-bg-dark-100": !this.isActive,
            "bg-border dark:bg-border-dark": this.isActive,
        };
    }
}
